// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".module__text h2[data-v-cbbf45aa]{font-size:3rem;max-width:20ch;line-height:1.25}.module__text p[data-v-cbbf45aa]{max-width:40ch}", ""]);
// Exports
module.exports = exports;
